import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function RelatedDocumentsReducer(state = initialState.document, action) {
	switch (action.type) {
		case types.GET_DOCUMENT: {
			if (action.meta && action.meta.apiInputInformation) {
				action.response.apiInputInformation = action.meta.apiInputInformation;
			}
			return _.cloneDeep(action.response);
		}
		case types.CLEAN_DOCUMENT: {
			return initialState.document;
		}
		case types.GET_DOCUMENT_BY_ID: {
			if (action.responseObj?.status === HttpStatusCodes.Ok && !action.fromUpdate) {
				return action.response;
			}
			return state;
		}
		default:
			return state;
	}
}
